import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { Gift, FileText, ClipboardList, TrendingUp } from 'lucide-react';
const bonuses = [{
  num: 'B1',
  icon: FileText,
  title: "El 'Script Book' Clínico",
  short: 'Guiones paso a paso',
  desc: 'Guiones verbatim listos para leer en sesión: inducciones hipnóticas, frases de resolución sistémica, técnica de Silla Vacía y protocolos de contención emocional.',
  image: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=600&q=70&auto=format&fit=crop&fm=webp',
  alt: 'Cuaderno abierto con guiones clínicos'
}, {
  num: 'B2',
  icon: ClipboardList,
  title: 'Kit Clínico de Plantillas',
  short: 'Imprimibles listos para usar',
  desc: 'Genograma Familiar Psicosomático, ficha de autoregistro de síntomas, cuestionario de apertura espiritual y Consentimiento Informado Multidimensional.',
  image: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=600&q=70&auto=format&fit=crop&fm=webp',
  alt: 'Plantillas clínicas y fichas impresas'
}, {
  num: 'B3',
  icon: TrendingUp,
  title: "Mentoría 'Del Consultorio al Premium'",
  short: 'Negocio ético de alto valor',
  desc: 'Empaqueta tu conocimiento en un proceso transformador de 8 semanas (High-Ticket) y aprende a atraer pacientes cualificados con copies éticos.',
  image: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=600&q=70&auto=format&fit=crop&fm=webp',
  alt: 'Mentoría profesional con laptop y notas'
}];
export const Bonuses = () => {
  return <section className="py-16 md:py-24 bg-navy relative text-cream overflow-hidden" data-id="element-18">
      <div className="absolute inset-0 bg-noise opacity-20 pointer-events-none" data-id="element-19"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-gold-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-20"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-21">
        <SectionHeading title="3 SÚPER BONOS VIP GRATIS" subtitle="Herramientas 'llave en mano' listas para aplicar mañana mismo en tu sesión" dark data-id="element-22" />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto mb-10" data-id="element-23">
          {bonuses.map((bono, i) => {
          const Icon = bono.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} whileHover={{
            y: -4
          }} className="bg-navy-800/70 backdrop-blur-sm rounded-sm border border-gold-500/25 overflow-hidden flex flex-col group" data-id="element-24">
                {/* Image header (compact aspect ratio) */}
                <div className="relative aspect-[16/9] overflow-hidden bg-navy-900" data-id="element-25">
                  <img src={bono.image} alt={bono.alt} loading="lazy" decoding="async" width={600} height={338} className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-500" data-id="element-26" />
                  {/* Gradient overlay for legibility */}
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/40 to-transparent" data-id="element-27"></div>

                  {/* GRATIS ribbon */}
                  <div className="absolute top-2 right-2 bg-gold-500 text-navy-900 text-[10px] font-bold tracking-widest px-2 py-1 rounded-sm flex items-center gap-1 shadow-md" data-id="element-28">
                    <Gift className="w-3 h-3" data-id="element-29" />
                    GRATIS
                  </div>

                  {/* Bonus number */}
                  <div className="absolute bottom-2 left-3 text-gold-400 font-serif text-xs tracking-widest" data-id="element-30">
                    BONO {bono.num}
                  </div>
                </div>

                {/* Content */}
                <div className="p-5 flex-1 flex flex-col" data-id="element-31">
                  <div className="flex items-start gap-2 mb-2" data-id="element-32">
                    <Icon className="w-4 h-4 text-gold-400 flex-shrink-0 mt-1" data-id="element-33" />
                    <div data-id="element-34">
                      <h3 className="font-serif font-bold text-lg text-cream leading-tight" data-id="element-35">
                        {bono.title}
                      </h3>
                      <p className="text-[11px] uppercase tracking-wider text-gold-400/80 font-medium mt-0.5" data-id="element-36">
                        {bono.short}
                      </p>
                    </div>
                  </div>
                  <p className="text-cream-200/75 text-sm leading-relaxed" data-id="element-37">
                    {bono.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-38">
          <div className="inline-block border-2 border-gold-500/50 px-6 py-3 rounded-sm bg-gold-500/10 backdrop-blur-sm" data-id="element-39">
            <h3 className="text-xl md:text-2xl font-serif text-gold-400 font-bold" data-id="element-40">
              VALOR TOTAL DE LOS BONOS:{' '}
              <span className="line-through text-gold-400/50" data-id="element-41">$56.000</span>{' '}
              <span className="text-cream" data-id="element-42">— HOY GRATIS</span>
            </h3>
          </div>
        </motion.div>
      </div>
    </section>;
};